<div class="max-w-5xl mx-auto p-4 sm:p-6">
  <div class="mb-6">
    <h2 class="text-2xl font-semibold text-gray-800">{{ 'integrations.title' | transloco }}</h2>
    <p class="text-sm text-gray-500 mt-1">{{ 'integrations.subtitle' | transloco }}</p>
  </div>

  <!-- Carregando -->
  <div *ngIf="isLoading" class="text-sm text-gray-600">
    {{ 'integrations.loading' | transloco }}
  </div>

  <!-- Erro -->
  <div *ngIf="!isLoading && loadError"
       class="p-3 bg-red-50 border border-red-200 rounded-md text-sm text-red-700">
    {{ 'integrations.loadError' | transloco }}
  </div>

  <!-- Cards de integrações -->
  <div *ngIf="!isLoading && !loadError"
       class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
    <div *ngFor="let integration of integrations; trackBy: trackByKey"
         class="bg-white border border-gray-200 rounded-lg shadow-sm p-5 flex flex-col">
      <div class="flex items-start justify-between">
        <div class="flex items-center gap-3 min-w-0">
          <div class="w-11 h-11 rounded-full bg-yellow-400 flex items-center justify-center shrink-0">
            <i class="fas fa-handshake text-white text-lg"></i>
          </div>
          <div class="min-w-0">
            <div class="text-base font-semibold text-gray-800 truncate">{{ integration.name }}</div>
            <span class="inline-flex items-center mt-1 px-2 py-0.5 text-xs rounded-full"
                  [ngClass]="integration.active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-700'">
              <span class="w-2 h-2 rounded-full mr-1"
                    [ngClass]="integration.active ? 'bg-green-500' : 'bg-gray-400'"></span>
              {{ (integration.active ? 'integrations.active' : 'integrations.inactive') | transloco }}
            </span>
          </div>
        </div>

        <!-- Toggle (desabilitado quando a integração não pode ser desativada) -->
        <label class="relative inline-flex items-center shrink-0"
               [class.cursor-not-allowed]="!integration.canDisable"
               [class.cursor-pointer]="integration.canDisable"
               [title]="(!integration.canDisable ? 'integrations.cannotDisable' : '') | transloco">
          <input type="checkbox" class="sr-only peer"
                 [checked]="integration.active"
                 [disabled]="!integration.canDisable">
          <div class="w-11 h-6 bg-gray-200 rounded-full transition-colors peer-checked:bg-green-500"
               [class.opacity-70]="!integration.canDisable"></div>
          <div class="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform peer-checked:translate-x-5"></div>
        </label>
      </div>

      <p class="text-sm text-gray-600 mt-4 flex-1">{{ integration.description }}</p>

      <div *ngIf="!integration.canDisable"
           class="mt-4 flex items-center gap-2 text-xs text-gray-500 border-t border-gray-100 pt-3">
        <i class="fas fa-lock"></i>
        <span>{{ 'integrations.cannotDisable' | transloco }}</span>
      </div>
    </div>
  </div>
</div>
